import classnames from "classnames";
import React, { FC, memo } from "react";
import { useTranslation } from "react-i18next";

import { Header } from "@/components/Header";
import { IProfileCompleteness, TCompletenessLevel } from "@/data/consultant-profiles";
import { Flex, Img } from "@/eworkitComponents";
import established from "@/views/ConsultantProfiles/Completeness/assets/badge-lvl-established.svg";
import fresh from "@/views/ConsultantProfiles/Completeness/assets/badge-lvl-fresh.svg";
import growing from "@/views/ConsultantProfiles/Completeness/assets/badge-lvl-growing.svg";
import prime from "@/views/ConsultantProfiles/Completeness/assets/badge-lvl-prime.svg";

import "./_level-badge.scss";

const levelBadges: Record<TCompletenessLevel, string> = {
  FRESH: fresh,
  GROWING: growing,
  ESTABLISHED: established,
  PRIME: prime,
};

interface LevelBadgeProps extends Pick<IProfileCompleteness, "level" | "score"> {
  variant?: string;
}

const BASE_CLASS = "completeness-level-badge";

export const LevelBadge: FC<LevelBadgeProps> = memo(({ level, score, variant }) => {
  const { t } = useTranslation("session");
  const headerColor = variant === "widget" ? "background-card" : "inherit";
  const headerWeight = variant === "widget" ? undefined : "bold";
  const align = variant === "widget" ? "flex-start" : "flex-end";
  const pointsSize = variant === "widget" ? "xl" : "xs";
  const pointsWeight = variant === "widget" ? "bolder" : undefined;
  const descriptionSize = variant === "widget" ? "md" : "xs";

  return (
    <>
      <Flex direction="column" align={align}>
        <Header size="md" color={headerColor} weight={headerWeight}>
          {t(`CONSULTANT_PROFILES.COMPLETENESS.LEVELS.${level}`)}
        </Header>
        <Header color={headerColor} size={descriptionSize}>
          <Header size={pointsSize} weight={pointsWeight}>
            {score}
          </Header>
          {` ${t("CONSULTANT_PROFILES.COMPLETENESS.POINTS")}`}
        </Header>
      </Flex>
      <Flex
        className={classnames(BASE_CLASS, {
          [`${BASE_CLASS}--${variant}`]: !!variant,
        })}>
        <Img src={levelBadges[level]} className={`${BASE_CLASS}-img`} />
      </Flex>
    </>
  );
});
